import i from "./ghl-ui.es1479.js";
import c from "./ghl-ui.es1480.js";
import m from "./ghl-ui.es1481.js";
import f from "./ghl-ui.es1291.js";
function d(t) {
  return function(r) {
    r = f(r);
    var o = c(r) ? m(r) : void 0, a = o ? o[0] : r.charAt(0), e = o ? i(o, 1).join("") : r.slice(1);
    return a[t]() + e;
  };
}
export {
  d as default
};
